const DashboardActionTypes = {
  FETCH_APPLICATION_REPORT_SUCCESS: 'FETCH_APPLICATION_REPORT_SUCCESS',
  FETCH_FINANCIAL_REPORT_SUCCESS: 'FETCH_FINANCIAL_REPORT_SUCCESS',

  FETCH_STATISTICS_FAILURE: 'FETCH_STATISTICS_FAILURE',
  FETCH_DASHBOARD_STATISTICS: 'FETCH_DASHBOARD_STATISTICS',

  EXPORT_DASHBOARD_START: 'EXPORT_DASHBOARD_START',
  EXPORT_DASHBOARD_SUCCESS: 'EXPORT_DASHBOARD_SUCCESS',
  EXPORT_DASHBOARD_FAILURE: 'EXPORT_DASHBOARD_FAILURE',
};
export default DashboardActionTypes;
